// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
    margin-left: auto;
    width: 20px;
    height: 20px;
    text-align: center;
    background-color: red;
    border-radius: 10px;
    color: white;
    line-height:20px;
}

.text-overflow {
    line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/common/menutabcontrol/accordion.menu.control.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".badge {\n    margin-left: auto;\n    width: 20px;\n    height: 20px;\n    text-align: center;\n    background-color: red;\n    border-radius: 10px;\n    color: white;\n    line-height:20px;\n}\n\n.text-overflow {\n    line-height: 1.4;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
